import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal, 
  TextField, 
  Typography
} from '@mui/material';

import useSelectedCompany from '../../../../../components/hooks/useSelectedCompany';
import useCurrencyService from '../../../../../components/hooks/useCurrencyService';
import AmountTextField from '../../../../../components/textFields/AmountTextField';
import LoadingButton from '../../../../../components/buttons/Button';

import { 
  CommitCompanyBlnkWalletTransactionBIZcore, 
  RefundCompanyBlnkWalletTransactionBIZcore, 
  VoidCompanyBlnkWalletTransactionBIZcore 
} from '../../../../../redux/actions/business/core/companyBlnkWalletActions';

import global from "../../../../../global.scss";

const Data = {
  Reference: "",
  Description: "",
  Amount: "",
  Currency: "USD",
  TransactionId: ""
};

const DomesticBlnkWalletModal = ({
  open, 
  setOpen, 
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const companyId = useSelectedCompany();
  const { handleCalculateAmount } = useCurrencyService();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(1);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(1);
  };

  useEffect(() => {
    try {
      if(open){
        if(update.defaultMode === 1){
          // mode = 1 - refund fees
          setMode(1);
        }else if(update.defaultMode === 2){
          // mode = 2 - commit transaction
          setMode(2);
        }else if(update.defaultMode === 3){
          // mode = 3 - void transaction
          setMode(3);
        }else{
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  // --------------- handle change ----------------
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if(mode === 1){
      // refund fees
      let obj = {
        transaction_type: "FEE_REFUND",
        reference: formData.Reference.trim() || "",
        description: formData.Description.trim()|| "",
        currency: formData.Currency || "USD",
        amount: handleCalculateAmount(update.Currency, formData.Amount || 0),
      }
      dispatch(RefundCompanyBlnkWalletTransactionBIZcore(companyId, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else if(mode === 2){
      // commit transaction
      let query = "";
      if(formData.Reference.trim()){
        query = `&reference=${formData.Reference.trim() || ""}`;
      } else {
        query = `&transaction_id=${formData.TransactionId || ""}`;
      };
      
      dispatch(CommitCompanyBlnkWalletTransactionBIZcore(companyId, query, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else if(mode === 3){
      // void transaction
      let query = "";
      if(formData.Reference.trim()){
        query = `&reference=${formData.Reference.trim() || ""}`;
      } else {
        query = `&transaction_id=${formData.TransactionId || ""}`;
      };
      
      dispatch(VoidCompanyBlnkWalletTransactionBIZcore(companyId, query, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        })
      });
    }else{
      toast.error("Invalid modal");
      handleClose();
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow"
        width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"}
            sx={{ padding: "15px"}}>
            <Typography variant='h6' sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>
            {
              mode === 1
              ?
              <>
                <Box 
                  className="flexCenterSBRow"
                  gap={"15px"}
                  mb={"15px"}>
                  <TextField 
                    label="Reference of the new refund transaction"
                    fullWidth
                    name="Reference"
                    value={formData.Reference}
                    onChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                    />
                </Box>
                <Box 
                  className="flexCenterSBRow"
                  gap={"15px"}
                  mb={"15px"}>
                  <TextField 
                    label="Description of the new refund transaction"
                    fullWidth
                    name="Description"
                    value={formData.Description}
                    onChange={handleChange}
                    inputProps={{ maxLength: 100 }}
                    />
                </Box>
                <AmountTextField
                  currencyName={"Currency"}
                  currency={formData.Currency}
                  onCurrencyChange={handleChange}
                  hideCurrencySelector={true}
                  label="Refund Amount"
                  fullWidth
                  name="Amount"
                  value={formData.Amount}
                  onChange={handleChange}
                  />
              </>
              :
                mode === 2 || mode === 3
                ?
                <>
                  <Box 
                    className="flexCenterSBRow"
                    gap={"15px"}
                    mb={"15px"}>
                    <TextField 
                      label="Reference"
                      fullWidth
                      name="Reference"
                      value={formData.Reference}
                      onChange={handleChange}
                      inputProps={{ maxLength: 100 }}
                      />
                  </Box>
                  <Typography
                    textAlign={"center"}>
                    OR
                  </Typography>
                  <Box 
                    className="flexCenterSBRow"
                    gap={"15px"}
                    mt={"15px"}
                    mb={"15px"}>
                    <TextField 
                      label="Transaction Id"
                      fullWidth
                      name="TransactionId"
                      value={formData.TransactionId}
                      onChange={handleChange}
                      inputProps={{ maxLength: 100 }}
                      />
                  </Box>
                </>
                :
                <></>
            }
            
          </Box>
          <Divider
           sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }}/>
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px"}}>
            <Button variant='text'
              onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton 
              variant='contained'
              loading={loading}
              disabled={
                mode === 1
                ? !(formData.Reference !== "" && formData.Description !== "" &&  handleCalculateAmount(update.Currency, formData.Amount || 0) > 0)
                : (mode === 2 || mode === 3)
                  ? (formData.Reference === "" && formData.TransactionId === "") 
                  : true
              }
              onClick={handleSubmit}>
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  )
}

export default DomesticBlnkWalletModal;